import { constants } from "src/app/configs/config-internal-constants";

export class CommonUtilities {

    // method to find whether its null.
    static isNull(value : any): boolean {
        return value === null;
    }

    // method to find whether its empty.
    static isEmpty(value : any): boolean {
        return value === '';
    }

    // method to find whether its undefined.
    static isUndefined(value : any): boolean {
        return value === undefined;
    }
  
    // method to find whether its Not null, Not empty and Not undefined.
    static isNotNullEmptyAndUndefined(value : any): boolean {
        return !this.isNull(value) && !this.isEmpty(value) && !this.isUndefined(value);
    }

    // method to check whether any two values are equal.
    static isEquals(value1 : any, value2 : any): boolean {
        return (this.isNotNullEmptyAndUndefined(value1) && this.isNotNullEmptyAndUndefined(value2)) 
        ? (value1.toString() === value2.toString()) 
        : false ;
    }

    static isBrand(brand: string): boolean {
        return brand === constants.BRAND_CAHOOT
        ? document.location.href.toLowerCase().indexOf("cahoot") > -1
        : document.location.href.toLowerCase().indexOf("cahoot") < 0;
    }
}